import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { Promo } from '../../core/models/order.model';
import { IconComponent } from './icon.component';
import { TranslatePipe } from '../pipes/translate.pipe';

interface ToneStyle { bg: string; fg: string; sub: string; }
const TONES: Record<string, ToneStyle> = {
  flame: { bg: 'linear-gradient(135deg, var(--brand) 0%, var(--brand-deep) 100%)', fg: '#fff', sub: 'rgba(255,255,255,0.86)' },
  ink: { bg: 'linear-gradient(135deg, #2a2622 0%, #14110e 100%)', fg: '#fff', sub: 'rgba(255,255,255,0.72)' },
  gold: { bg: 'linear-gradient(135deg, #f2b441 0%, #d98a1f 100%)', fg: '#211606', sub: 'rgba(33,22,6,0.7)' },
};

/** Horizontal promo/offer card. */
@Component({
  selector: 'app-promo-card',
  standalone: true,
  imports: [IconComponent, TranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `<div (click)="tap.emit(promo)" [style.background]="tones.bg" [style.color]="tones.fg"
      style="width:280px;flex-shrink:0;height:132px;border-radius:18px;cursor:pointer;padding:18px;
             position:relative;overflow:hidden;display:flex;flex-direction:column;justify-content:space-between">
      <div style="position:absolute;inset-inline-end:-26px;top:-26px;width:120px;height:120px;border-radius:50%;background:rgba(255,255,255,0.1)"></div>
      <app-icon name="solar:ticket-sale-bold" [size]="26" style="opacity:0.9"></app-icon>
      <div>
        <div style="font-family:var(--brand-display);font-weight:700;font-size:18px;line-height:1.12;letter-spacing:-0.02em">{{ promo.title | t }}</div>
        <div [style.color]="tones.sub" style="font-size:12px;margin-top:4px">{{ promo.sub | t }}</div>
      </div>
    </div>`,
})
export class PromoCardComponent {
  @Input() promo!: Promo;
  @Output() tap = new EventEmitter<Promo>();
  get tones(): ToneStyle { return TONES[this.promo.tone] || TONES['ink']; }
}
